<ng-template>
  <section
    cdkTrapFocus
    cdkTrapFocusAutoCapture
    class="tw-relative"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="title()"
  >
    <div class="tw-overflow-hidden tw-rounded-xl tw-shadow-lg">
      <div
        class="tw-relative tw-z-20 tw-w-72 tw-break-words tw-bg-primary-100 tw-pb-4 tw-pt-2 tw-text-main"
      >
        <div class="tw-me-2 tw-flex tw-items-start tw-justify-between tw-gap-4 tw-ps-4">
          <h2 bitTypography="h5" class="tw-font-medium tw-mt-1">
            {{ title() }}
          </h2>
          <button
            type="button"
            bitIconButton="bwi-close"
            [label]="'close' | i18n"
            (click)="closed.emit()"
            size="small"
          ></button>
        </div>
        <div bitTypography="body2" class="tw-px-4">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
    <div class="bit-popover-arrow"></div>
  </section>
</ng-template>
